import CommonSettings from "../utils/CommonSettings";

class APPUrls {
  constructor() {
    this.initUrls();
  }

  initUrls() {
    this.API_BASE_URL = CommonSettings.SERVER_BASE_URL;
    this.URL_GET_PRODUCT_LICENCES_FOR_USER = this.API_BASE_URL + "license/getLicensePurchasedbyUser";

    this.URL_GET_PRODUCT_LICENCES = this.API_BASE_URL + "license/getLicense";

    this.URL_GET_PRODUCTS = this.API_BASE_URL + "products/getProducts";
    this.URL_ASSIGN_LICENCE = this.API_BASE_URL + "license/assignLicense";
    this.URL_GET_USERS = this.API_BASE_URL + "user/getUsers";
    this.URL_ADD_USER = this.API_BASE_URL + "user/addUser";
    this.URL_UPDATE_ASSIGN_LICENCE =
      this.API_BASE_URL + "license/updatelicenceassignedtouser";
    this.URL_REMOVE_USER_ASSIGNED_TO_PRODUCT =
      this.API_BASE_URL + "license/removeUserAssignedToProduct";
    this.URL_REMOVE_USER = this.API_BASE_URL + "user/removeUser";
    this.URL_UPDATE_USER = this.API_BASE_URL + "user/updateUser";
    this.URL_LOGIN = this.API_BASE_URL + "user/login";
    this.URL_GET_ASSIGNED_PRODUCTS_TO_USER =
      this.API_BASE_URL + "user/fetchuserassignedproducts";

  }
}

export default new APPUrls();
